"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextToHighlight = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var getSearchWordsWithIndex = function getSearchWordsWithIndex(searchText) {
  return searchText.toLowerCase().split(' ').filter(function (word) {
    return word;
  }).map(function (word, index) {
    return {
      word: word,
      index: index
    };
  });
};

var getSpanText = function getSpanText(data) {
  if (typeof data !== 'object' || !data) {
    return '';
  }

  return data.text.toLowerCase();
};

var qualifyWordMatch = function qualifyWordMatch(searchWord, sequence) {
  var THRESHOLD = 0.8;
  var searchWordLength = searchWord.length;
  var sequenceLength = sequence.length;

  if (sequenceLength === 0) {
    return {
      isMatch: false,
      matchScore: 0
    };
  }

  var matchScore = sequenceLength / searchWordLength;
  return {
    isMatch: matchScore >= THRESHOLD,
    matchScore: matchScore
  };
};

var getStartEnd = function getStartEnd(str, sub) {
  if (!sub) {
    return {
      start: -1,
      end: -1
    };
  }

  var start = str.indexOf(sub[0]); // Find the first character match

  if (start === -1) return {
    start: -1,
    end: -1
  };
  var matchLength = 0; // Compare characters one by one until mismatch or end of either string

  while (matchLength < sub.length && matchLength < str.length && str[start + matchLength] === sub[matchLength]) {
    matchLength++;
  }

  return {
    start: start,
    end: start + matchLength
  };
};

var getRowId = function getRowId(data) {
  if (typeof data !== 'object' || !data) {
    return '';
  }

  return data.rowId;
};

var getPossibleMatchesByWord = function getPossibleMatchesByWord(searchData, searchWord) {
  var matches = [];
  var searchState = searchWord;
  var sequence = '';
  var spanToCharIdx = {}; // Try all matches within spans

  for (var _i = 0, _Object$entries = Object.entries(searchData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
        groupTitle = _Object$entries$_i[0],
        groupData = _Object$entries$_i[1];

    var _iterator = (0, _createForOfIteratorHelper2.default)(groupData.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            spanIdx = _step$value[0],
            data = _step$value[1];

        var spanText = getSpanText(data);
        var spanTextWords = spanText.split(' ');
        var currentPosition = 0; // Track position in the entire spanText

        var _iterator2 = (0, _createForOfIteratorHelper2.default)(spanTextWords.entries()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
                spanWordIdx = _step2$value[0],
                spanWord = _step2$value[1];

            if (sequence.length === 1) {
              // Reset state
              searchState = searchWord;
              sequence = '';
              spanToCharIdx = {};
            }

            var _getStartEnd = getStartEnd(spanWord, searchState),
                start = _getStartEnd.start,
                end = _getStartEnd.end;

            if (start === 0) {
              var matchText = spanWord.slice(start, end);
              searchState = searchState.slice(end);
              sequence += matchText; // Use currentPosition to calculate the actual start/end in the spanText

              var spanStart = currentPosition + start;
              var spanEnd = currentPosition + end;
              spanToCharIdx[spanIdx] = {
                start: spanStart,
                end: spanEnd,
                matchText: matchText
              };

              var _qualifyWordMatch = qualifyWordMatch(searchWord, sequence),
                  isMatch = _qualifyWordMatch.isMatch,
                  matchScore = _qualifyWordMatch.matchScore;

              if (isMatch) {
                matches.push({
                  matchText: sequence,
                  location: spanToCharIdx,
                  matchScore: matchScore,
                  rowId: getRowId(data)
                }); // Reset state

                searchState = searchWord;
                sequence = '';
                spanToCharIdx = {};
              }
            }

            var isLastWord = spanWordIdx === spanTextWords.length - 1; // Update currentPosition to include the word length and space

            currentPosition += spanWord.length;

            if (!isLastWord) {
              currentPosition += 1; // Add 1 for the space between words
              // Reset state

              searchState = searchWord;
              sequence = '';
              spanToCharIdx = {};
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return matches;
};

var getPossibleMatches = function getPossibleMatches(searchData, searchWords) {
  var matchesByWordIdx = {};

  var _iterator3 = (0, _createForOfIteratorHelper2.default)(searchWords),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
          word = _step3$value.word,
          index = _step3$value.index;
      matchesByWordIdx[index] = {
        word: word,
        matches: getPossibleMatchesByWord(searchData, word)
      };
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return matchesByWordIdx;
};

var getMatchDistance = function getMatchDistance(match1, match2, expectedOrder) {
  var span1 = Number(Object.keys(match1.location)[0]);
  var span2 = Number(Object.keys(match2.location)[0]);
  var distance;

  if (span1 === span2) {
    var pos1 = match1.location[span1].end;
    var pos2 = match2.location[span2].start;
    distance = Math.abs(pos2 - pos1);
  } else {
    distance = Math.abs(span2 - span1) * 100;
  } // Much larger penalty for wrong order relative to search text


  if (expectedOrder === 'after' && span2 < span1 || expectedOrder === 'after' && span1 === span2 && match2.location[span2].start < match1.location[span1].end) {
    distance += 1000000; // Much larger penalty for wrong order
  }

  return distance;
};

var findClosestMatch = function findClosestMatch(searchWordsWithIndex, matchesBySequence) {
  var searchWordIndexes = searchWordsWithIndex.map(function (word) {
    return word.index;
  }).filter(function (i) {
    return i !== 0;
  });
  var firstWordMatches = matchesBySequence[0].matches;
  var bestSequence = null;
  var bestScore = Infinity;

  var _iterator4 = (0, _createForOfIteratorHelper2.default)(firstWordMatches),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var firstMatch = _step4.value;
      var currentSequence = [firstMatch];
      var lastMatch = firstMatch;
      var currentScore = 0;

      var _iterator5 = (0, _createForOfIteratorHelper2.default)(searchWordIndexes),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var wordIndex = _step5.value;
          var wordMatches = matchesBySequence[wordIndex].matches;
          var bestNextMatch = null;
          var bestDistance = Infinity;

          var _iterator6 = (0, _createForOfIteratorHelper2.default)(wordMatches),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var match = _step6.value;
              var distance = getMatchDistance(lastMatch, match, 'after');

              if (distance < bestDistance) {
                bestDistance = distance;
                bestNextMatch = match;
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (bestNextMatch) {
            currentScore += bestDistance; // Add the distance to the current sequence score

            currentSequence.push(bestNextMatch);
            lastMatch = bestNextMatch;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (currentScore < bestScore) {
        // Compare current sequence score with best score
        bestScore = currentScore;
        bestSequence = currentSequence;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return bestSequence || [];
};

var getHighlightPositions = function getHighlightPositions() {
  var closestMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!closestMatch.length) {
    return [];
  }

  var rowIds = [];

  var _iterator7 = (0, _createForOfIteratorHelper2.default)(closestMatch),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var match = _step7.value;
      rowIds.push(match.rowId);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return rowIds;
}; // MAIN


var getTextToHighlight = function getTextToHighlight(searchData, searchText) {
  try {
    var searchWords = getSearchWordsWithIndex(searchText); // Now store matches by sequence position instead of by word

    var possibleMatches = getPossibleMatches(searchData, searchWords);
    var closestMatch = findClosestMatch(searchWords, possibleMatches);
    var rowIds = getHighlightPositions(closestMatch);
    return rowIds;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return [];
  }
};

exports.getTextToHighlight = getTextToHighlight;